import React, { useState } from 'react';
import { Form, NavDropdown } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { selectLoggedInUserActiveLocation, selectLoggedInUserInfo, selectLoggedInUserLocations } from '../../../../store/slices/auth-slice';
import { updateUser } from '../../../../store/slices/users-slice';

function ActiveLocationNavItem(props) {
  const loggedInUserLocations = [...useSelector(selectLoggedInUserLocations)].sort((a, b) => a.LocationName?.localeCompare(b.LocationName, undefined, { sensitivity: 'base' }));
  const userInfo = useSelector(selectLoggedInUserInfo);
  const currentUserActiveLocation = useSelector(selectLoggedInUserActiveLocation);
  const dispatch = useDispatch();

  const [searchTerm, setSearchTerm] = useState('');

  const onClick = (locationId) => {
    const updateUserInfo = { ...userInfo };
    updateUserInfo.locationPreference = locationId;
    dispatch(updateUser({ userId: userInfo.userId, user: updateUserInfo }));
  };

  const activeDropDownLink = (LinkLocationId) => {
    return currentUserActiveLocation?.LocationID === LinkLocationId;
  };

  // Reset the search filter whenever the dropdown is opened or closed.
  const onToggle = () => setSearchTerm('');

  const filteredLocations = loggedInUserLocations.filter((location) => {
    return location.LocationName?.toLowerCase().includes(searchTerm.trim().toLowerCase());
  });

  return (loggedInUserLocations && loggedInUserLocations.length) ? (
    <NavDropdown
      title={userInfo?.locationPreference ? `Active Location: ${currentUserActiveLocation?.LocationName}` : 'Set your active location'}
      style={{ textAlign: 'right' }}
      id="nav-dropdown"
      onToggle={onToggle}
      active
    >
      <div className="px-3 py-2">
        <Form.Control
          type="text"
          size="sm"
          autoFocus
          placeholder="Search locations..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          onClick={(e) => e.stopPropagation()}
          onKeyDown={(e) => e.stopPropagation()}
        />
      </div>
      <div style={{ maxHeight: '50vh', overflowY: 'auto' }}>
        {filteredLocations.length ? filteredLocations.map((location, index) => {
          return (
            <NavDropdown.Item
              onClick={() => onClick(location.LocationID)}
              eventKey={`nav-location-${index}`}
              key={`nav-location-${location.LocationID}`}
              active={activeDropDownLink(location.LocationID)}
            >
              {location.LocationName}
            </NavDropdown.Item>
          );
        }) : (
          <div className="px-3 py-2 text-muted">No locations found</div>
        )}
      </div>
      <NavDropdown.Divider />
      <NavDropdown.Item as={Link} active={false} to="/profile" eventKey="activeLocation">Update in profile</NavDropdown.Item>
    </NavDropdown>
  ) : null;
}

export default ActiveLocationNavItem;
